import React from 'react';
import moment from 'moment';
import { ChevronRight } from '@mui/icons-material';

import Currencies from 'arbitrip-common/general/utils/Currencies';

import CashWalletConstants from './CashWalletConstants';
import StatusIndicator from './StatusIndicator.react';

const { REQUEST_STATUS, DATE_FORMAT, DEFAULT_CURRENCY } = CashWalletConstants;

const RequestRow = ({ request, currency, onOpen }) => {
    const handleOpen = () => onOpen(request);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onOpen(request);
        }
    };

    const isRejected = request.status === REQUEST_STATUS.REJECTED;
    const amountClass = isRejected
        ? 'cash-wallet-request-amount cash-wallet-request-amount-rejected'
        : 'cash-wallet-request-amount';

    return (
        <div
            className="cash-wallet-request-row"
            role="button"
            tabIndex={0}
            onClick={handleOpen}
            onKeyDown={handleKeyDown}
        >
            <span className="cash-wallet-request-id">{request.short_id}</span>
            <StatusIndicator status={request.status} />
            <span className="cash-wallet-request-date">
                {moment(request.submitted_at).format(DATE_FORMAT)}
            </span>
            <span className={amountClass}>
                {Currencies.getPriceWithCurrency(request.amount, currency || DEFAULT_CURRENCY)}
            </span>
            <ChevronRight className="cash-wallet-request-chevron" fontSize="small" />
        </div>
    );
};

export default RequestRow;
